<template>
    <el-card class="dashboard-panel-list" :body-style="{padding: '15px'}">
        <div class="header">
            <div>{{title}}</div>
            <slot name="header-button"></slot>
        </div>
        <divider-line customStyle="margin: 10px 0px;"/>
        <div class="remark panel-body" :style="bodyStyle" v-if="dataList.length">
            <slot v-bind:rowData="data" v-for="(data, index) in dataList"></slot>
        </div>
        <div v-if="!dataList.length" class="empty-tip">没有数据</div>
    </el-card>
</template>

<script>
export default {
    name: "PanelList",
    props: {
        title: String,
        dataList: {
            type: Array,
            default: []
        },
        bodyStyle:
        {
            type: String,
            default: ''
        }
    },
    data()
    {
        return {}
    }
}
</script>

<style lang="scss" scoped>
@import "~@/styles/common.scss";
.dashboard-panel-list
{
    margin-top: 12px;
    margin-right: 12px;
    color: #333333;
    font-size: 14px;
}
.dashboard-panel-list .header
{
    font-size: 16px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}
.dashboard-panel-list .empty-tip
{
    text-align: center;
    font-size: 10px;
    color: #999999;
}
</style>



// WEBPACK FOOTER //
// src/modules/erp/components/render/PanelList.vue